module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    staticClass: "agency-main",
    staticStyle: {
      "padding-bottom": "70px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResp && _vm.baseInfo.stepCurrent),
      expression: "hasResp && baseInfo.stepCurrent"
    }],
    staticClass: "propress-line",
    staticStyle: {
      "padding": "32px 0",
      "background": "#fff"
    }
  }, [_c('my-step', {
    attrs: {
      "step": _vm.baseInfo.stepCurrent,
      "totalstep": _vm.baseInfo.stepTotal
    }
  })], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "userName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userName),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userName", $$v)
      },
      expression: "propData.userName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "documentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "value": _vm.iDCardTypesLabel(_vm.propData.documentsType),
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "idCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.propData, "idCardNo", $$v)
      },
      expression: "propData.idCardNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "documentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件有效期",
      "placeholder": "证件号码有效期",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.documentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.propData, "documentsValidity", $$v)
      },
      expression: "propData.documentsValidity"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [(_vm.isForeign(_vm.propData.documentsType)) ? _c('x-input', {
    ref: "userCountry",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "国籍",
      "placeholder": "请输入国籍",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.propData.userCountry),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userCountry", $$v)
      },
      expression: "propData.userCountry"
    }
  }) : _vm._e(), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.userSex),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userSex", $$v)
      },
      expression: "propData.userSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.propData.userAge),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userAge", $$v)
      },
      expression: "propData.userAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "职业",
      "options": ['党政机关、事业单位', '企业单位', '自由业主', '学生', '军人', '其他'],
      "placeholder": '请选择职业',
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.userOccupation),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userOccupation", $$v)
      },
      expression: "propData.userOccupation"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userPosition),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userPosition", $$v)
      },
      expression: "propData.userPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userLandline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "placeholder": "请输入座机",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userLandline),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userLandline", $$v)
      },
      expression: "propData.userLandline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "placeholder": "请输入手机",
      "required": ""
    },
    model: {
      value: (_vm.propData.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userMobile", $$v)
      },
      expression: "propData.userMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userEmail),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userEmail", $$v)
      },
      expression: "propData.userEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "zip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "邮编",
      "max": 6,
      "type": "number",
      "keyboard": "number",
      "placeholder": "请输入邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.zip),
      callback: function($$v) {
        _vm.$set(_vm.propData, "zip", $$v)
      },
      expression: "propData.zip"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "userAddress",
    attrs: {
      "title": "住址",
      "autosize": "",
      "placeholder": "请输入住址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userAddress),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userAddress", $$v)
      },
      expression: "propData.userAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-con"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isFund ? '一、私募基金投资者，最近20个交易日金融资产均不得低于人民币300万元，或者最近3年个人年均收入不低于人民币50万元' :
    '一、资产管理计划投资者，具有2年以上投资经历，且满足以下条件之一：家庭金融净资产不低于300万元，家庭金融资产不低于500万元，或者近3年本人年均收入不低于40万元') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.userAssetsScale.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、是否满足下列条件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px 0"
    }
  }, [_vm._v("\n          （1）金融资产不低于500万元人民币，或者最近3年个人年均收入不低于50万元人民币；\n          （2）具有2年以上证券、基金、期货、黄金、外汇等投资经历，或 者具有2年以上金融产品设计、投资、风险管理及相关工作经 历的自然人投资者，或者属于《证券提货投资者适当性管理 办法》第八条第(一)款所规定的专业投资者的高级管理人 员、获得职业资格认证的从事金融相关业务的注册会计师和 律师。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.userInvestmentExperience.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.isControllingShareholder.checked))]), _vm._v(" "), (_vm.data.isControllingShareholder.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.data.isControllingShareholder.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.transactionActualBeneficiary.checked))]), _vm._v(" "), (_vm.data.transactionActualBeneficiary.checked === '他人') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.data.transactionActualBeneficiary.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.isBadFaith.checked))]), _vm._v(" "), (_vm.data.isBadFaith.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.data.isBadFaith.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "notice-text"
  }, [_vm._v("\n        以上资料为您的理财师在特定对象确认程序时向您获取并上传至系统用于适当性管理留痕，经您本人在线确认视为您对该材料真实、完整、准确、有效性的认可。若以上资料与您实际资料不符，请您联系理财师进行修改，确保您提供给理财师的资料真实、有效、准确、完整，并对您提供的资料承担责任。\n      ")])]), _vm._v(" "), (_vm.baseInfo.isShowBtn) ? _c('submit-button', {
    on: {
      "click": _vm.$_personal_submit
    }
  }, [_vm._v("确定")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e86d926"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Personal/OneLook.vue
// module id = 1081
// module chunks = 1